import React, { Component } from "react";
import { connect } from "react-redux";
import SRHCopyright from "./../../../../components/SRHCopyright";
import ReportHeader from "./../../../../components/ReportHeader";
import Printable from "./../../../../components/Printable";
import { Header } from "semantic-ui-react";
import { AppendixBody, AppendixFooter } from "./style.js";
import _ from "lodash";
import Grid from "@material-ui/core/Grid";
import FiltersFooter from "../FiltersFooter";

class Appendix extends Component {
  render() {
    const { totalRespondents, datasetName, workSettingsSurveyed, workSettings, version } = this.props.summaryReport;
    const { unit, ready, page, landscape } = this.props;
    const workSettingPages = [];
    const workSettingsFiltered = _.filter(workSettings, function (workSetting) {
      return workSetting.expected_responses;
    });
    if (ready) {
      const datasetUnitName = this.props.summaryReport.datasetUnitName
        ? this.props.summaryReport.datasetUnitName
        : "Work Setting";
      const numPerPage = landscape ? 14 : 21;
      const responseMin = version.region === "UK" ? 4 : 5;
      for (let i = 0; i < workSettingsFiltered.length; i += numPerPage) {
        const pageNumber = page + i / numPerPage;
        workSettingPages.push(
          <Printable key={`appendix-${pageNumber}`} page={pageNumber} landscape={landscape}>
            <ReportHeader
              title={`Appendix: ${datasetUnitName} Response Rates${i === 0 ? "" : " (cont.)"}`}
              totalRespondents={totalRespondents}
              workSettingsSurveyed={workSettingsSurveyed}
              datasetName={datasetName}
              unit={unit}
              summaryReport={this.props.summaryReport}
            />
            <AppendixBody>
              <div className="data-table">
                <Grid container className="row extra-bottom-pad-row">
                  <Grid item className="column" />
                  <Grid item className="column">
                    <Header as="h3">Response Rate</Header>
                  </Grid>
                  <Grid item className="column">
                    <Header as="h3">
                      # Responses <span style={{ position: "absolute", right: "-3px" }}>/</span>
                    </Header>
                  </Grid>
                  <Grid item className="column">
                    <Header as="h3">Denominator</Header>
                  </Grid>
                </Grid>
                {_.slice(workSettingsFiltered, i, i + numPerPage).map(row => {
                  return (
                    <Grid container className="row" key={row.unit}>
                      <Grid item className="column">
                        <Header
                          as="h4"
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            marginRight: -50,
                          }}
                          title={`${row.unit}${row.response_rate < 40 ? "*" : ""}${row.count < responseMin ? "†" : ""}`}
                        >
                          {row.unit}
                          {row.response_rate < 40 && "*"}
                          {row.count < responseMin && <sup>†</sup>}
                        </Header>
                      </Grid>
                      <Grid item className="column">
                        {row.response_rate}%
                      </Grid>
                      <Grid item className="column">
                        {row.count}
                      </Grid>
                      <Grid item className="column">
                        {row.expected_responses}
                      </Grid>
                    </Grid>
                  );
                })}
              </div>
            </AppendixBody>
            <AppendixFooter>
              <p>* {datasetUnitName} had a response rate of less than 40%</p>
              <p>
                † {datasetUnitName} had fewer than {responseMin} responses
              </p>
            </AppendixFooter>
            <FiltersFooter />
            <SRHCopyright textClass="large-font" />
          </Printable>
        );
      }
    } else {
      workSettingPages.push(<Printable key="loading" />);
    }
    return <div>{workSettingPages}</div>;
  }
}
export default connect(store => {
  return {
    summaryReport: store.summaryReport.summaryReport,
  };
})(Appendix);



// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/Appendix/index.jsx